import polyglotI18nProvider from 'ra-i18n-polyglot';
import plMessages from 'ra-language-polish';
import customPlMessages from './customMessages/pl';
import merge from 'lodash.merge';

// Deep merge the base Polish translations with our custom overrides
const mergedMessages = merge({}, plMessages, customPlMessages);

const messages = {
    pl: mergedMessages,
};

const i18nProvider = polyglotI18nProvider(locale => messages[locale], 'pl');

export default i18nProvider;